<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subject Enrollment Details
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Filter subject enrollment data by various parameters.
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="auto">
          <b-form-select
            size="lg"
            v-model="cohort"
            :options="cohortOptions"
          ></b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-form-select
            size="lg"
            v-model="selectedClusterNumber"
            :options="clusterNumbers"
          ></b-form-select>
        </b-col>
        <b-col>
          <b-form-select
            size="lg"
            v-model="subject_enrollment"
            :options="subject_enrollment_options"
          ></b-form-select>
        </b-col>
        <b-col cols="auto">
          <h2>
            <b-badge>
              {{options.totalRows}}
            </b-badge>
          </h2>
        </b-col>
        <b-col cols="auto">
          <b-button size="lg" @click="download()">
            Download
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <br>

    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="data"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
        <template v-slot:cell(subject_age)="data">
            {{roundAge(data.value)}}
        </template>
        <template v-slot:cell(subject_age_at_enrollment)="data">
            {{roundAge(data.value)}}
        </template>
    </b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 10,
        perPage: 20
      },
      loading: false,
      search: "",
      selectedClusterNumber: "",
      clusterNumbers: [],
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      cohort: 'Longitudinal',
      cohortOptions: ['Longitudinal', 'Febrile'],
      subject_enrollment: "Enrollment Complete",
      subject_enrollment_options: [
        "Enrollment Complete",
        "Screening Failures",
        // "Refused",
        "LTFU"
      ]
    };
  },
  computed: {},
  watch: {
    subject_enrollment: function() {
    //   this.$refs.table.refresh();
    this.find();
    },
    cohort: function() {
    //   this.$refs.table.refresh();
    this.find();
    },
    selectedClusterNumber: function() {
    //   this.$refs.table.refresh();
    this.find();
    }
  },
  created() {
    this.clusterNumbers = [{value: "", text: "All Clusters"}];
    for(let x = 1; x <= 30; x++) {
      this.clusterNumbers.push({value: x, text: x});
    }

    this.find();
  },
  mounted: function(){},
  methods: {
    myProvider(ctx) {
      const that = this;

      return HTTP.get("/srilanka/metrics/subject-enrollment", {
        params: {
          subject_enrollment: that.subject_enrollment,
          cohort: that.cohort,
          page: ctx.currentPage,
          count: ctx.perPage,
          sortBy: that.sortBy,
          sortDesc: that.sortDesc ? "" : "yes"
        }
      })
        .then(response => {
          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
          });
          that.fields = fields;

          that.data = response.data.data;
          // that.fields = response.data.fields;
          that.options.totalRows = parseInt(response.data.total);
          return that.data;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          return [];
        });
    },
    find() {
      const that = this;

      HTTP.get("/srilanka/metrics/subject-enrollment", {
        params: {
          subject_enrollment: that.subject_enrollment,
          cohort: that.cohort,
          cluster_number: that.selectedClusterNumber
        }
      })
        .then(response => {
          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
          });
          that.fields = fields;

          that.data = response.data.data;
          // that.fields = response.data.fields;
          that.options.totalRows = parseInt(response.data.total);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    download() {
      const that = this;

      let csv = '';
      let fields = _.values(_.mapValues(that.fields, 'key'));

      csv += fields.join(',') + '\n';

      _.each(that.data, function(item) {
        let row = [];
        _.each(fields, function(field) {
          row.push(item[field]);
        });
        csv += row.join(',') + '\n';
      });

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = `subject-enrolled-${that.subject_enrollment}.csv`;
      hiddenElement.click();
    },
    roundAge(age) {
      let num = parseFloat(age);
      return _.isNaN(num) ? 0.0 : _.floor(num, 1);
    }
  }
};
</script>

<style></style>
